export default __webpack_public_path__ + "img/bvhABlQN.47e001c9.svg";